import { LogOutSquareIcon } from '../../assets/icons/common';
import { setExitExamModal } from '../../store/exam/slice';
import { useDispatch } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function ExitExam() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const close = () => dispatch(setExitExamModal(false));

    const exit = () => {
        navigate('/workspace');
        dispatch(setExitExamModal(false));
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Exit exam'
            closeFunc={close}
            icon={<LogOutSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: close,
            }}
            confirmButton={{
                text: 'Exit',
                type: 'Error',
                onClick: exit,
            }}
        >
            <span className={styles.title}>
                Are you sure you want to exit exam?
            </span>
            <p className={styles.description}>
                If you exit the exam, you will lose your<br />
                opportunity to be evaluated for this job!
            </p>
        </Modal>
    )
}
